<template>
	<div class="video-heading-image" :class="type">
		<div class="video-overlay">
			<div class="video-overlay-layer keyhole" />
			<div class="video-overlay-layer lock" />
		</div>
		<div style="padding: 56.25% 0 0; position: relative">
			<iframe
				:src="`${video}?loop=1&muted=1&badge=0&autoplay=1&controls=0&autopause=0&player_id=0`"
				frameborder="0"
				allow="autoplay; fullscreen; picture-in-picture"
				allowfullscreen
				style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; z-index: 2"
				title="Vondel Hotels"
			/>
		</div>
	</div>
</template>

<script setup>
defineProps({
	video: { type: String, default: '' },
	type: { type: String, default: '' },
});
</script>

<style lang="scss" scoped>
.video-heading-image {
	position: relative;
	margin-top: 38px;
	overflow: hidden;
	background-color: #fdf9f4;

	.video-overlay {
		position: absolute;
		inset: -1px;
		z-index: 4;
		opacity: 1;
		transition: all 0.3s ease-in-out;

		.video-overlay-layer {
			position: absolute;
			inset: -1px;
			z-index: 4;
			opacity: 0;

			&.lock {
				z-index: 5;
				background: url('~/assets/images/lock-image.png') no-repeat center center;
				background-size: cover;
				animation-name: fade-out;
				animation-duration: 4s;
				animation-iteration-count: 1;
			}

			&.keyhole {
				background: url('~/assets/images/lock-keyhole.png') no-repeat center center;
				background-size: cover;
				animation-name: fade-out-enlarge;
				animation-duration: 9s;
				animation-iteration-count: 1;

				&::before,
				&::after {
					content: '';
					display: block;
					background: #fdf9f4;
					z-index: 3;
					position: absolute;
					left: 0;
					bottom: 0;
					top: 0;
					width: calc(50% - 500px);
					height: 100%;
				}

				&::after {
					left: auto;
					right: 0;
				}
			}
		}
	}

	&.landscape {
		max-height: calc(100vh - 38px);
	}

	&.portrait {
		display: none;
		margin-top: 38px;
	}
}

@keyframes fade-out {
	0% {
		opacity: 1;
	}

	50% {
		opacity: 1;
	}

	100% {
		opacity: 0;
	}
}

@keyframes fade-out-enlarge {
	0% {
		opacity: 1;
		transform: scale(1);
	}

	50% {
		opacity: 1;
		transform: scale(1);
	}

	70% {
		opacity: 1;
		transform: scale(100);
	}

	90% {
		opacity: 1;
		transform: scale(110);
	}

	100% {
		opacity: 0;
		transform: scale(120);
	}
}

@media (max-width: 1200px) {
	.video-heading-image {
		margin-top: 72px;

		&.landscape {
			max-height: calc(100vh - 72px);
		}
	}
}

@media (max-width: 680px) {
	.video-heading-image {
		min-height: 640px;

		&.portrait {
			display: block;
		}

		&.landscape {
			display: none;
		}

		iframe {
			width: 360% !important;
			height: 130% !important;
			margin-left: -130% !important;
			min-height: 680px !important;
		}
	}
}

@media (max-width: 520px) {
	.video-heading-image {
		min-height: 600px;

		iframe {
			width: 300% !important;
			height: 120% !important;
			margin-left: -100% !important;
			min-height: 600px !important;
		}
	}
}
</style>
